export default __webpack_public_path__ + "static/media/course1.44c32c83.webp";